<template>
  <div>
    <!--        <div>-->
    <!--          <h2>Search and add a pin</h2>-->
    <!--          <label>-->
    <!--            <gmap-autocomplete-->
    <!--              @place_changed="setPlace">-->
    <!--            </gmap-autocomplete>-->
    <!--            <button @click="addMarker">Add</button>-->
    <!--          </label>-->
    <!--          <br/>-->
    <!--        </div>-->
    <!--    <br>-->
    <gmap-map
      :center="center"
      :zoom="13"
      style="width:100%; height: 70vh;">
      <gmap-marker
        :key="index"
        v-for="(m, index) in items"
        :position="m.position"
        :title="m.description"
        :icon="m.connectStatus == 1 ? '/static/img/marker-icon.png' : ''"
        @click="clickMarker(m.position)">
      </gmap-marker>.
    </gmap-map>
  </div>
</template>

<script>
export default {
  name: "GoogleMap",
  props: {
    items: Array
  },
  data() {
    return {
      //mặc định là Montreal
      center: {
        lat: 22.1336421, lng: 105.7826459
      },
    };
  },

  mounted() {
  },

  methods: {
    setPlace(place) {
      this.currentPlace = place;
    },
    geolocate: function () {
      // navigator.geolocation.getCurrentPosition(position => {
      //   this.center = {
      //     lat: position.coords.latitude,
      //     lng: position.coords.longitude
      //   };
      // });
    },
    clickMarker(position) {

    }
  }
};
</script>
